import { Injectable, inject } from '@angular/core';
import { FirebaseAnalytics } from '@capacitor-community/firebase-analytics';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs';
import { AnalyticActions } from './analytic.actions';
import { AnalyticState } from './analytic.state';

/**
 * @description Analytic Effects.
 * @exports
 * @class AnalyticEffects
 */
@Injectable()
export class AnalyticEffects {
  private readonly actions = inject(Actions);

  readonly onAnalyticLog = createEffect(
    () => {
      return this.actions.pipe(
        ofType(AnalyticActions.log),
        tap((options) => {
          this.log(options);
        })
      );
    },
    { dispatch: false }
  );

  /**
   * @description Log event.
   * @param {AnalyticState} options Options.
   * @memberof AnalyticEffects
   */
  log(options: AnalyticState): void {
    document.addEventListener(
      'deviceready',
      () => {
        FirebaseAnalytics.logEvent(options as any);
      },
      false
    );
  }
}
